// Execute code when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('Document is fully loaded and parsed.');
    // Add any additional initialization code here

    LoadSliderElementor();

    function LoadSliderElementor() {
        const slider = document.querySelector('.anwalt-slider');

        if( !slider) return;

        const prevBtn = document.getElementById('prevBtn');
        const nextBtn = document.getElementById('nextBtn');

        let scrollAmount = 0;
        const scrollStep = 110; // Each item's width + gap

        // Next button
        nextBtn.addEventListener('click', () => {
            console.log('Clicked!');
            scrollAmount += scrollStep;
            slider.style.transform = `translateX(-${scrollAmount}px)`;
        });

        // Prev button
        prevBtn.addEventListener('click', () => {
            scrollAmount = Math.max(scrollAmount - scrollStep, 0);
            slider.style.transform = `translateX(-${scrollAmount}px)`;
        });
    }
});

import './front/counter';
import './front/logo';
import './front/paged';
import './front/filter';
import './front/comment';
import './front/hamburger';
import './front/faq';
import './front/posts';